module.exports = __webpack_public_path__ + "media/drivehorizon.26fa1b11.mp4";